var map = {
	"./2023/autumn/poster/team_honor_champion.png": "4e6b",
	"./2024/winter/poster/team_honor_champion.png": "bd76",
	"./2025/spring/poster/team_honor_champion.png": "36b1",
	"./2025/summer/poster/team_honor_champion.png": "82fb",
	"./2025/winter/poster/team_honor_champion.png": "223e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4306";